import React from 'react'

type PropTypes = {
  currentUser: Object,
  todoItems: Array<Object>,
}

class ToDoList extends React.Component {
  constructor(props: PropTypes) {
    super(props)
  }

  render() {
    if (!this.props.todoItems || !this.props.todoItems.length) {
      return null
    }
    let rows = []
    for (let rowIndex = 0; rowIndex < this.props.todoItems.length; rowIndex++) {
      const todoItem = this.props.todoItems[rowIndex]
      const className = 'is-new site-header__nav-baloon-menu clearfix'
      rows.push(
        <li className={className} key={rowIndex}>
          <a
            href={todoItem.link}
            data-tag={rowIndex}
            className="link-black link-borderless"
          >
            <p className="site-header__nav-baloon-message-content">
              {todoItem.content}
            </p>
          </a>
        </li>,
      )
    }
    return (
      <div>
        <h2 key="title" className="site-header__nav-baloon-title">
          やることリスト
        </h2>
        <ul>{rows}</ul>
      </div>
    )
  }
}

export default ToDoList



// WEBPACK FOOTER //
// ./src/components/shared/header/ToDoList.jsx